import Axios from "axios";
import React, { Component } from "react";
import { Card, Button } from "antd";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

const { Meta } = Card;

class ListMovieComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      movies: null,
      statusForm: "read",
      title: "",
      description: "",
      year: "",
      duration: "",
      genre: "",
      review: "",
      rating: "",
      image_url: "",
      isFlipped: false,
    };
  }

  componentDidMount() {
    if (this.state.movies === null) {
      const url = `https://backendexample.sanbersy.com/api/data-movie`;
      Axios.get(url).then((res) => {
        const value = res.data;
        this.setState({
          movies: value,
        });
      });
    }
  }

  render() {
    return (
      <>
        <Row className="mt-5">
          {this.state.movies !== null &&
            this.state.movies.map((m, index) => {
              console.log(m.id);
              return (
                <Col md="4" xs="12" className="mt-5 mb-5" key={index}>
                  <Card
                    hoverable
                    style={{ width: 240 }}
                    cover={<img alt="example" src={m.image_url} />}
                  >
                    <Meta title={m.title} description={m.genre} />
                    <Link to={`/movie/${m.id}`}>
                      <Button className="mt-2">View More</Button>
                    </Link>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </>
    );
  }
}
export default ListMovieComponent;
